import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_63rejl12p8: FaireBrandEntity = {
  token: "b_63rejl12p8",
  type: "brand",
  name: "Forces of Nature",
  avatarUrl:
    "https://cdn.faire.com/fastly/c0fdb09492b6b87b1f1ffa49e19b64ce18ca74308844281ff82fcc85b850ba64.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/77014ca65df6fe8289103170d852996bed2cef18c4d7f76f4af4e946053094a9.png",
  logoUrl:
    "https://cdn.faire.com/fastly/c0fdb09492b6b87b1f1ffa49e19b64ce18ca74308844281ff82fcc85b850ba64.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/77014ca65df6fe8289103170d852996bed2cef18c4d7f76f4af4e946053094a9.png",
  location: "Sonoma, CA, USA",
  minimumOrderDollars: 150,
  rating: 5,
  reviewCount: 1,
  isInsider: true,
  description:
    "Forces of Nature is the pioneer in natural, organic medicine since 1999. We produce trusted plant-based remedies for everyday ailments from First Aid, Pain Management, Skin Care and Antifungals to Cough & Cold and everyday Stress and Focus needs. Our bespoke, optimized formulas, developed in-house by Dr. Peter Klapper, Ph.D., combine carefully targeted homeopathic medicines with pure essential oils. \n\nWe're proud to offer only all natural products with no colorants, no dyes, no artificial preservatives, no fillers, and no synthetic ingredients. You can trust that all of our products meet our Clean Medicine Standard - a higher bar for natural wellbeing. All Forces of Nature products are Certified Organic to the USDA standard and have been Non-GMO Project Verified. Our oils and finished formulas are cruelty free - with our topicals being Leaping Bunny certified.\n\nMade in the USA with globally sourced ingredients, our homeopathic medicines are manufactured by us directly in our FDA registered facility to meet exacting quality and purity standards. Our small team fulfills your orders directly from our Sonoma, CA warehouse.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:44:36.495Z",
    importedBy: "entity-db-cli",
  },
};
